import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { PATIENTS_REPOSITORY } from '../domain/repositories/patients.repository';
import { PATIENT_DOCUMENTS_REPOSITORY } from '../domain/repositories/patient-documents.repository';
import { PATIENT_CODELIST_REPOSITORY } from '../domain/repositories/patient-codelist.repository';
import { CLINICAL_REPORT_REPOSITORY } from '../domain/repositories/clinical-report.repository';
import { CLINICAL_TEXT_TEMPLATES_REPOSITORY } from '../domain/repositories/clinical-text-templates.repository';
import { CLINICAL_REPORT_PROMPT_VERSIONS_REPOSITORY } from '../domain/repositories/clinical-report-prompt-versions.repository';
import { PatientsRemoteDatasource } from './datasources/remote/patients.remote-datasource';
import { PatientDocumentsRemoteDatasource } from './datasources/remote/patient-documents.remote-datasource';
import { PatientCodelistRemoteDatasource } from './datasources/remote/patient-codelist.remote-datasource';
import { ClinicalTextTemplatesRemoteDatasource } from './datasources/remote/clinical-text-templates.remote-datasource';
import { ClinicalReportPromptVersionsRemoteDatasource } from './datasources/remote/clinical-report-prompt-versions.remote-datasource';
import { ClinicalReportsRemoteDatasource } from './datasources/remote/clinical-reports.remote-datasource';
import { PatientMapper } from './mappers/patient.mapper';
import { ClinicalHistoryMapper } from './mappers/clinical-history.mapper';
import { InvoiceMapper } from './mappers/invoice.mapper';
import { PatientDocumentMapper } from './mappers/patient-document.mapper';
import { PatientCodelistMapper } from './mappers/patient-codelist.mapper';
import { ClinicalReportMapper } from './mappers/clinical-report.mapper';
import { ClinicalTextTemplateMapper } from './mappers/clinical-text-template.mapper';
import { ClinicalReportPromptVersionMapper } from './mappers/clinical-report-prompt-version.mapper';
import { PatientsRepositoryImpl } from './repositories/patients.repository.impl';
import { PatientDocumentsRepositoryImpl } from './repositories/patient-documents.repository.impl';
import { PatientCodelistRepositoryImpl } from './repositories/patient-codelist.repository.impl';
import { ClinicalReportRepositoryImpl } from './repositories/clinical-report.repository.impl';
import { ClinicalTextTemplatesRepositoryImpl } from './repositories/clinical-text-templates.repository.impl';
import { ClinicalReportPromptVersionsRepositoryImpl } from './repositories/clinical-report-prompt-versions.repository.impl';

export function providePatientsData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    PatientsRemoteDatasource,
    PatientDocumentsRemoteDatasource,
    PatientCodelistRemoteDatasource,
    ClinicalTextTemplatesRemoteDatasource,
    ClinicalReportPromptVersionsRemoteDatasource,
    ClinicalReportsRemoteDatasource,
    PatientMapper,
    ClinicalHistoryMapper,
    InvoiceMapper,
    PatientDocumentMapper,
    PatientCodelistMapper,
    ClinicalReportMapper,
    ClinicalTextTemplateMapper,
    ClinicalReportPromptVersionMapper,
    { provide: PATIENTS_REPOSITORY, useClass: PatientsRepositoryImpl },
    { provide: PATIENT_DOCUMENTS_REPOSITORY, useClass: PatientDocumentsRepositoryImpl },
    { provide: PATIENT_CODELIST_REPOSITORY, useClass: PatientCodelistRepositoryImpl },
    { provide: CLINICAL_REPORT_REPOSITORY, useClass: ClinicalReportRepositoryImpl },
    { provide: CLINICAL_TEXT_TEMPLATES_REPOSITORY, useClass: ClinicalTextTemplatesRepositoryImpl },
    { provide: CLINICAL_REPORT_PROMPT_VERSIONS_REPOSITORY, useClass: ClinicalReportPromptVersionsRepositoryImpl },
  ]);
}
